import React from 'react';
import gql from 'graphql-tag';
import { curry } from 'lodash';
import { Mutation } from 'react-apollo';

import { RequestLineFieldsFragment } from '../constants';
import { NAME as REQUEST_LINES_QUERY } from '../withCaseRequestLines';
import { CASE_REQUEST_ASSETS_QUERY_NAME } from '../../RequestAssetsForm/withRequestAssets/caseRequestAssetsQuery';

const NAME = 'compositions_CaseRequestPanel_resetSupplied';

const mutation = gql`
  mutation ${NAME} ($id: ID!) {
    resetSupplied(input: { id: $id }) {
      requestSuppliedLine {
        supplied
        suppliedLine { ...RequestLineFields }
      }
    }
  }
  ${RequestLineFieldsFragment}
`;

const buildMutationChild = curry((WrappedComponent, componentProps, mutate) => (
  <WrappedComponent
    {...componentProps}
    resetRequestSuppliedLine={id => mutate({ variables: { id } })}
  />
));

const withRemoveCaseSuppliedLineMutation = WrappedComponent => componentProps => (
  <Mutation
    mutation={mutation}
    refetchQueries={[REQUEST_LINES_QUERY, CASE_REQUEST_ASSETS_QUERY_NAME]}
  >
    {buildMutationChild(WrappedComponent, componentProps)}
  </Mutation>
);

export default withRemoveCaseSuppliedLineMutation;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestSuppliedLinesActions/withResetCaseSuppliedLineMutation.js